"use strict";

angular.module("vendor")
.factory("SaleRepresentativeAssignmentFactory", function($resource, FlashBag, gettextCatalog, appConfig) {
        var addSectionResource = $resource(appConfig.API_SERVER + "/sales-representatives/add-customers/:id/", {id: "@id"}, {
            query: {
                method: "GET",
                isArray: false
            },
            save: {
                method: "POST"
            },
            update: {
                method: "PATCH",
                ignoreLoadingBar: true
            }
        });
        var manageSectionResource = $resource(appConfig.API_SERVER + "/sales-representatives/manage-customers/list/:id/", {id: "@id"}, {
            query: {
                method: "GET",
                isArray: false
            },
            save: {
                method: "POST"
            },
            update: {
                method: "PATCH",
                ignoreLoadingBar: true
            }
        });

        var assignSelectedResource = $resource(appConfig.API_SERVER + "/sales-representatives/selected-customers/assign/", {}, {
            save: {
                method: "POST",
                ignoreLoadingBar: true
            }
        });
        var selectedDeleteResource = $resource(appConfig.API_SERVER + "/sales-representatives/selected-customers/delete/");

        function getBulkActionParams() {
            return {
                delete: {
                    text: gettextCatalog.getString("Delete selected"),
                    message: gettextCatalog.getString("Do you really want to delete these customer assignations?"),
                    resource: selectedDeleteResource,
                    modalTemplatePrefix: "partnership",
                    modalTemplatePackage: "vendor"
                }
            };
        }

        function getSortFields() {
            return {
                company_name: {
                    name: gettextCatalog.getString("Name"),
                    normal: gettextCatalog.getString("A to Z"),
                    reverse: gettextCatalog.getString("Z to A")
                },
                buyer_number: {
                    name: gettextCatalog.getString("Customer #"),
                    normal: gettextCatalog.getString("0 to 9"),
                    reverse: gettextCatalog.getString("9 to 0")
                },
                status_date: {
                    name: gettextCatalog.getString("Status Date"),
                    normal: gettextCatalog.getString("Past to Future"),
                    reverse: gettextCatalog.getString("Future to Past")
                }
            };
        }

        function getFilter() {
            var values = [];
            var filterValues = getFilterValues();

            angular.forEach(filterValues, function(value, key) {
                values.push({
                    Value: key,
                    Name: value
                });
            });

            return values;
        }

        return {
            query: function(userVendorId, search, page, ordering, filters) {
                ordering = ordering || "company_name";
                var params = {
                    search: search,
                    page: page,
                    reference_id: userVendorId,
                    ordering: ordering
                };

                params = angular.extend(params, filters);

                return addSectionResource.query(params,
                    function onSuccess(data) {
                    },
                    function onError(response) {
                        FlashBag.apiError(response);
                    }
                );
            },
            updateAllSelected: function(userVendorId, search, selected, ordering, page, filters) {
                ordering = ordering || "company_name";
                var params = {
                    search: search,
                    reference_id: userVendorId,
                    selected: selected,
                    ordering: ordering,
                    page: page
                };

                params = angular.extend(params, filters);

                return addSectionResource.save(params,
                    function onSuccess(data) {
                    },
                    function onError(response) {
                        FlashBag.apiError(response);
                    }
                );
            },
            updateSingleSelected: function(userVendorId, selected, id) {
                var params = {
                    reference_id: userVendorId,
                    selected: selected,
                    id: id
                };
                return addSectionResource.update(params,
                    function onSuccess(data) {
                    },
                    function onError(response) {
                        FlashBag.apiError(response);
                    }
                );
            },
            updateAssignedAllSelected: function(userVendorId, search, selected, ordering, page, filters) {
                ordering = ordering || "company_name";
                var params = {
                    search: search,
                    reference_id: userVendorId,
                    selected: selected,
                    ordering: ordering,
                    page: page
                };

                params = angular.extend(params, filters);

                return manageSectionResource.save(params,
                    function onSuccess(data) {
                    },
                    function onError(response) {
                        FlashBag.apiError(response);
                    }
                );
            },
            updateAssignedSingleSelected: function(userVendorId, selected, id) {
                var params = {
                    reference_id: userVendorId,
                    selected: selected,
                    id: id
                };
                return manageSectionResource.update(params,
                    function onSuccess(data) {
                    },
                    function onError(response) {
                        FlashBag.apiError(response);
                    }
                );
            },
            queryAssigned: function(userVendorId, search, page, ordering, filters) {
                ordering = ordering || "company_name";
                var params = {
                    search: search,
                    page: page,
                    reference_id: userVendorId,
                    ordering: ordering
                };

                params = angular.extend(params, filters);

                return manageSectionResource.query(params,
                    function onSuccess(data) {
                    },
                    function onError(response) {
                        FlashBag.apiError(response);
                    }
                );
            },

            assignSelected: function(userVendorId) {
                var params = {
                    reference_id: userVendorId
                };
                return assignSelectedResource.save(params);
            },
            getAddSectionSelected: function(userVendorId) {
                var params = {
                    reference_id: userVendorId
                };

                return assignSelectedResource.query(params);
            },
            getSortFields: getSortFields,
            getFilter: getFilter,
            getBulkActionParams: getBulkActionParams,
            getSingleActionParams: getBulkActionParams
        }
    }
);



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/sale-representative/sale-representative-assignment.factory.js
// module id = 885
// module chunks = 0